import { PostList } from '../PostList'

function PostListLayout({
  emptyStateActions = null,
  getShowEmptyListRules,
  listPage,
  onHideWelcomePost,
}) {
  const { getThresholdItemProps, items, listLoading, updateListData } = listPage

  return (
    <PostList
      emptyStateActions={emptyStateActions}
      getShowEmptyListRules={getShowEmptyListRules}
      getThresholdItemProps={getThresholdItemProps}
      items={items}
      loading={listLoading}
      onHideWelcomePost={onHideWelcomePost}
      onReload={updateListData}
    />
  )
}

export default PostListLayout
